import { useState, useReducer, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

import { getCaseId, getClientId } from "../../../Utils/helper";
import api, { api_without_cancellation } from "../../../api/api";
// import ButtonLoader from "../../Loaders/ButtonLoader";
// import SendEmailPopUp from "../../WordProcessor/SendEmailPopUp";
import SendEmailPopUpCourtForm from "../SendEmailPopUpCourtForm";

const CourtFormPageSideMenu = ({
  _litigationId,
  _docId,
  _fetchEditDocs,
  _type,
  _container,
  docName,
  courtFormId,
  formDataContext,
  openCourtForm,
  showPdf,
  setShowPdf,
  isSaveDisabled,
}) => {
  docName = docName ?? "Court Form Draft";
  const origin = process.env.REACT_APP_BACKEND_URL;

  const [emailPopUp, setEmailPopUp] = useState(false);
  const [_saveLoading, setSaveLoading] = useState(false);

  // Dispatch work
  const initialState = {
    filename: "",
    updatedFileName: "",
    show: false,
    loading: false,
    error: false,
    status: "",
    draftId: "",
    tempName: "",
  };

  function reducer(state, action) {
    switch (action.type) {
      case "SET_LOADING":
        return { ...state, loading: action.payload };
      case "SET_ERROR":
        return { ...state, error: action.payload };
      case "SET_FILENAME":
        return { ...state, filename: action.payload };
      case "SET_UPDATED_FILENAME":
        return { ...state, updatedFileName: action.payload };
      case "SHOW_MODAL":
        return { ...state, show: true, status: action.payload };
      case "HIDE_MODAL":
        return { ...state, show: false };
      case "SET_DRAFT_ID":
        return { ...state, draftId: action.payload };
      case "SET_TEMP_NAME":
        return { ...state, tempName: action.payload };
      default:
        return state;
    }
  }

  const [countdown, setCountdown] = useState(5); // Initialize countdown to 5 seconds
  const [state, dispatch] = useReducer(reducer, initialState);
  const redirectToFirmSetting = async () => {
    const redirect_url = "/bp-litigation/" + getClientId() + "/" + getCaseId();
    window.location.href = redirect_url;
  };

  useEffect(() => {
    if (state.show) {
      setCountdown(5);

      const timer = setTimeout(() => {
        dispatch({ type: "HIDE_MODAL" });
        redirectToFirmSetting();
      }, 5000);

      const countdownInterval = setInterval(() => {
        setCountdown((prev) => (prev > 0 ? prev - 1 : 0));
      }, 1000);

      return () => {
        clearTimeout(timer);
        clearInterval(countdownInterval);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.show, dispatch]);

  // const deleteEditDoc = async () => {
  //   try {
  //     const formData = new FormData();
  //     formData.append("doc_id", docId);

  //     const response = await api_without_cancellation.post(
  //       `${origin}/api/delete-edit-doc/`,
  //       formData
  //     );
  //     if (response.status === 200) {
  //       if (response.data.success) {
  //         fetchEditDocs();
  //       }
  //     }
  //   } catch (error) {
  //     console.error("An error occurred:", error);
  //   }
  // };

  const deleteEditDocWithPopUp = async () => {
    try {
      // await deleteEditDoc();
      dispatch({
        type: "SHOW_MODAL",
        payload: `${docName} closed successfully!`,
      });
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  // const saveDraft = async () => {
  //   try {
  //     const content =
  //       await container.current?.documentEditor.saveAsBlob("Docx");
  //   } catch (error) {
  //     console.error("Error saving document:", error);
  //   }

  //   dispatch({
  //     type: "SHOW_MODAL",
  //     payload: "Doc Updated successfully!",
  //   });
  // };

  const downloadDocument = async () => {
    const formData = new FormData();

    formData.append("case_id", getCaseId());
    formData.append("client_id", getClientId());
    formData.append("court_form_id", courtFormId);
    formData.append("context", JSON.stringify(formDataContext));

    try {
      const response = await api_without_cancellation.post(
        `${origin}/api/court-form/download-courtform/`,
        formData,
        {
          responseType: "blob", // binary data
        }
      );

      // Extract filename from content-disposition
      let fileName = "court form draft.docx";
      const disposition = response.headers["content-disposition"];
      if (disposition && disposition.includes("filename=")) {
        fileName = disposition.split("filename=")[1].trim().replace(/"/g, "");
      }

      // Create blob URL
      const url = window.URL.createObjectURL(response.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();

      // Cleanup
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading document:", error);
    }
  };

  const printDoc = async () => {
    const formData = new FormData();

    formData.append("case_id", getCaseId());
    formData.append("client_id", getClientId());
    formData.append("court_form_id", courtFormId);
    formData.append("context", JSON.stringify(formDataContext));

    try {
      const response = await api_without_cancellation.post(
        `${origin}/api/court-form/print-courtform/`,
        formData
      );
      const { data } = response.data;
      const pdfBlob = new Blob([Uint8Array.from(atob(data), (c) => c.charCodeAt(0))], {
        type: "application/pdf",
      });
      const url = URL.createObjectURL(pdfBlob);
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = url;
      document.body.appendChild(iframe);
      iframe.onload = () => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        iframe.addEventListener("afterprint", () => {
          document.body.removeChild(iframe);
          URL.revokeObjectURL(url);
        });
      };
    } catch (error) {
      console.error("Error printing document:", error);
    }
  };

  const attachPdfToCaseFile = async () => {
    setSaveLoading(true);
    const formData = new FormData();
    formData.append("case_id", getCaseId());
    formData.append("client_id", getClientId());
    formData.append("court_form_id", courtFormId);
    formData.append("context", JSON.stringify(formDataContext));
    try {
      const response = await api.post(`${origin}/api/court-form/save-courtform/`, formData);
      if (response.status === 200) {
        const { data, filename } = response.data;
        const pdfBlob = new Blob([Uint8Array.from(atob(data), (c) => c.charCodeAt(0))], {
          type: "application/pdf",
        });
        const url = URL.createObjectURL(pdfBlob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);

        // await deleteEditDoc();
      }
    } catch (error) {
      console.error("Error printing document:", error);
    } finally {
      setSaveLoading(false);
    }
  };

  const _pdfToCaseFile = async () => {
    try {
      await attachPdfToCaseFile();
      dispatch({
        type: "SHOW_MODAL",
        payload: `${docName} Attached To Case Successfully`,
      });
    } catch (error) {
      console.error("Error printing document:", error);
    }
  };

  const sendEmail = () => {
    setEmailPopUp(true);
  };

  const handleCloseEmailPopUp = () => {
    setEmailPopUp(false);
  };

  return (
    <>
      <div className="bottom-content side-bar-padding">
        <div
          className="m-b-5 m-l-0 m-r-0 six-buttons"
          // style={{ display: "flex", flexDirection: "column", gap: "5px" }}
        >
          {/* <button
            className="btn btn-primary col height-25 d-flex align-items-center justify-content-center"
            style={{
              fontWeight: "600",
              fontSize: "14px",
            }}
            onClick={pdfToCaseFile}
          >
            {saveLoading ? (
              <ButtonLoader />
            ) : type === "GenerateDocument" ? (
              "Save As Draft"
            ) : type === "CourtForm" ? (
              "Save as DOC"
            ) : (
              "Save"
            )}
          </button> */}
          <button
            className="btn btn-primary col height-25 d-flex align-items-center justify-content-center"
            onClick={openCourtForm}
            style={{
              fontWeight: "600",
              fontSize: "14px",
            }}
          >
            Generate Form
          </button>

          {/* PDF */}
          <span>
            {showPdf ? (
              <button
                className={
                  "height-25 d-flex align-items-center justify-content-center btn btn-success"
                }
                onClick={() => setShowPdf(false)}
                style={{
                  fontWeight: "600",
                  fontSize: "14px",
                }}
              >
                Hide PDF
                {/* <i className="ic ic-19 ic-generate-document ms-1" /> */}
              </button>
            ) : (
              <button
                className={`height-25 d-flex align-items-center justify-content-center btn ${!isSaveDisabled ? "btn-success" : "btn-secondary"} `}
                onClick={() => setShowPdf(true)}
                style={{
                  fontWeight: "600",
                  fontSize: "14px",
                }}
                disabled={isSaveDisabled}
              >
                Show PDF
                {/* <i className="ic ic-19 ic-generate-document ms-1" /> */}
              </button>
            )}
          </span>

          <button
            className="btn btn-primary col height-25 d-flex align-items-center justify-content-center"
            onClick={deleteEditDocWithPopUp}
            style={{
              fontWeight: "600",
              fontSize: "14px",
            }}
          >
            Close as DOC
          </button>

          <button
            className="btn btn-primary col height-25 d-flex align-items-center justify-content-center"
            style={{
              fontWeight: "600",
              fontSize: "14px",
            }}
            onClick={printDoc}
          >
            Print
          </button>

          <button
            className="btn btn-primary col height-25 d-flex align-items-center justify-content-center"
            style={{
              fontWeight: "600",
              fontSize: "14px",
            }}
            onClick={downloadDocument}
          >
            Download DOC
          </button>

          <button
            className="btn btn-primary col height-25 d-flex align-items-center justify-content-center"
            style={{
              fontWeight: "600",
              fontSize: "14px",
            }}
            onClick={sendEmail}
          >
            Email PDF
          </button>
        </div>
      </div>

      <SendEmailPopUpCourtForm
        emailPopUp={emailPopUp}
        handleCloseEmailPopUp={handleCloseEmailPopUp}
        attachPdfToCaseFile={attachPdfToCaseFile}
        // container={container}
        docName={docName}
        courtFormId={courtFormId}
        formDataContext={formDataContext}
      />

      <Modal
        show={state.show}
        onHide={() => {
          dispatch({ type: "HIDE_MODAL" });
          redirectToFirmSetting();
        }}
      >
        <Modal.Header>
          <Modal.Title>{state.status}</Modal.Title>
        </Modal.Header>
        <Modal.Footer
          className="mt-0"
          style={{
            borderTop: "none",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Button
            variant="secondary"
            onClick={() => {
              dispatch({ type: "HIDE_MODAL" });
              redirectToFirmSetting();
            }}
            style={{ marginBottom: "10px" }} // Adds space between button and countdown text
          >
            Dismiss
          </Button>
          <div style={{ textAlign: "center", fontSize: "0.9rem" }}>
            Automatically closing in {countdown} seconds...
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CourtFormPageSideMenu;
